import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const path = '/reports/';
    const paths = {
        endpointSave: config.endpoints.backend + 'demonstratives/save',
        endpointGetById: config.endpoints.backend + 'demonstratives/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Parecer",
        labelTitleEdit: "Editar Parecer",
        labelTitleView: 'Visualizar Parecer'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                pdc_demonstrative_type_id: keys?.default_foreign_key?.pdc_demonstrative_types?.report
            },
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'publish_date',
                    type: 'date',
                    label: 'Data Base',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'obs',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: false
                    },
                    maxLength: 100
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
